export const iconFontAwesomeTextformattingIndent = (
	<i className="fa-solid fa-indent"></i>
);
